// Null component that will render nothing -- for use with Code Splitting / Loadable
export const Null = (_props: any) => {
  return null;
};
